'use client'

import classNames from 'classnames'
import type { HTMLAttributes, ReactNode } from 'react'

interface ITableRowProps extends HTMLAttributes<HTMLTableRowElement> {
  className?: string
  children: ReactNode
}

export const PktTableRow = ({ className, children, ...props }: ITableRowProps) => (
  <tr className={classNames(className, 'pkt-table__row', {})} role="row" {...props}>
    {children}
  </tr>
)
